import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import styles from './SideModal.module.scss';
import RoundedButton from '../../atoms/roudedButton/RoundedButton';
const closeBtn = '/icons/close.svg';
import Text from '../../atoms/text/Text';
import { closeAllModals } from '../../../app/globals/slice/sideModalSlice/SideModalSlice';
import { useTranslation } from 'react-i18next';
import useIsRtl from '../../../app/helpers/isRtl';

const SideModal = ({
  isbackdropped,
  children,
  style,
  title,
  isFromTop,
  className = '',
  isOpenModal,
  onClose,
  titleClassname = '',
  isMobile,
  headerClassname = '',
  headerComponent = null,
  contentClassName = '',
  textColor,
  isWhiteClose,
}) => {
  const isRtl = useIsRtl();
  const dispatch = useDispatch();
  const [shouldRender, setShouldRender] = useState(isOpenModal);
  const [isAnimated, setIsAnimated] = useState(false);

  // this use effect is to make sure the SideModal doesn't appear in the DOM, until we open it
  // adding the animation with it
  useEffect(() => {
    let animationTimeoutId;
    let renderTimeoutId;

    if (isOpenModal) {
      setShouldRender(true);
      // window.isHoveringCalendar = true;
      animationTimeoutId = setTimeout(() => {
        setIsAnimated(true);
      }, 100);
      document.body.style.overflow = 'hidden';
    } else {
      setIsAnimated(false);
      // window.isHoveringCalendar = false;
      renderTimeoutId = setTimeout(() => {
        setShouldRender(false);
      }, 500);
    }

    return () => {
      clearTimeout(animationTimeoutId);
      clearTimeout(renderTimeoutId);
      if (isOpenModal) {
        document.body.style.overflow = '';
      }
    };
  }, [isOpenModal]);

  const handleClose = () => {
    onClose && onClose();
    dispatch(closeAllModals());
  };

  const modalClassName = isFromTop
    ? `${styles['side-modal-top']} ${isAnimated ? styles.open : ''} ${className}`
    : `${!isRtl ? styles['side-modal-right'] : styles['side-modal']} ${isAnimated ? styles.open : ''} ${className}`;

  const backdropClassName = isOpenModal
    ? `${styles.backdrop} ${styles.open} ${isRtl ? '' : styles['is-ltr']}`
    : styles.backdrop;

  if (!shouldRender) return null;

  return (
    <>
      <div
        style={style}
        className={modalClassName}
        onMouseEnter={() => (window.isHoveringCalendar = true)}
        onMouseLeave={() => (window.isHoveringCalendar = false)}
      >
        {headerComponent}
        <div
          className={`${styles['modal-content']} ${isRtl ? styles.rtl : null} ${contentClassName}`}
        >
          <div
            className={`${styles['modal-header']} ${isRtl ? 'rtl' : null} ${headerClassname}`}
          >
            <Text
              variant="text-bold-italic-20"
              title={title}
              style={{ textTransform: 'uppercase', color: textColor }}
              className={`${styles.title} ${titleClassname}`}
            />
            {isMobile ? null : (
              <div
                className={`${styles['modal-close']} ${isWhiteClose ? styles['white-image'] : ''}`}
              >
                <RoundedButton
                  svg={closeBtn}
                  onClick={handleClose}
                  classname={styles.closeSvg}
                />
              </div>
            )}
          </div>
          {children}
        </div>
      </div>
      {isOpenModal && isbackdropped ? (
        <div className={backdropClassName} onClick={handleClose}></div>
      ) : null}
    </>
  );
};

export default SideModal;
